module.exports = __webpack_public_path__ + "static/ppc-slider-right-4da9cc64f42732ef84272781b783c5a5.svg";